import Button from '@eversports/klimt-primitives/legacy/Button'
import Link from '@eversports/klimt-primitives/legacy/Link'
import Stack from '@eversports/klimt-primitives/legacy/Stack'
import Text from '@eversports/klimt-primitives/legacy/Text'

import NotFoundImage from '../../../static/not-found.svg'
import { Localized } from '../../localization/react'

const NotFoundMatch = () => {
  return (
    <Stack justifyContent="center" alignItems="center" flex={1}>
      <img src={NotFoundImage} alt="Not Found Image" style={{ maxWidth: '750px' }} />
      <Link to="/">
        <Button variant="primary" sx={{ px: 2, py: 1 }}>
          <Text variant="badge" sx={{ color: 'white' }}>
            <Localized id="match-not-found-call-to-action" />
          </Text>
        </Button>
      </Link>
    </Stack>
  )
}

export default NotFoundMatch
